"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.context = void 0;
exports.context = {
    "media.3d": "3D view",
    "media.video": "Video"
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9taWNyby1jb3B5L2NvbnRleHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxPQUFPLEdBQUc7SUFDckIsVUFBVSxFQUFFLFNBQVM7SUFDckIsYUFBYSxFQUFFLE9BQU87Q0FDdkIsQ0FBQyJ9